import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'disableCopy',
    standalone: false
})
export class DisableCopyPipe implements PipeTransform {

  transform(value: number): boolean {
    return value < 1;
  }
}
